import React from "react";
import {Navbar,Container,NavbarBrand} from "reactstrap"
import { Box, Link } from "@mui/material";
import config from "config";

const getCopyrightYearString = () => {
    let current = new Date().getFullYear();
    let start = 2018
    return current>start ? start + ' - ' + current : start;
  };

function Footer(props) {
    return (
        <Box className="footer d-flex" sx={{justifyContent: "space-between"}}>
            <Box></Box>
            <Box>
                © {getCopyrightYearString()} Powered by AXIM Fringe Solutions Group, LLC. All rights reserved.
            </Box>
            <Box className="pe-2">
                <Link rel="noopener noreferrer" href="/release-notes" target="_blank" sx={{ color: "black" }}>
                    {/* config.build.number will be set in release script */}
                    {config.build.number.indexOf("{{") !== 0 ? config.build.number : ""}
                </Link>
            </Box>
        </Box>
    )
}

export default Footer